"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSuffix = exports.FormManager = void 0;
/* eslint-disable no-console */
var lodash_1 = require("lodash");
var lodash_2 = require("lodash");
var mobx_1 = require("mobx");
var yup = __importStar(require("yup"));
var FormManager = /** @class */ (function () {
    function FormManager(formData, validationSchema) {
        var _this = this;
        this.repeatedFormData = {};
        this.isSubmitting = false;
        this.errors = [];
        this.ignoreValidationOnTheseFields = new Set();
        this.setValidationSchema = function (newValidationSchema) {
            _this._validationSchema = newValidationSchema;
        };
        this.getValidationSchema = function () {
            return _this._validationSchema;
        };
        /**
         * Return an `onChange` handler for the property provided via the name parameter
         */
        this.getChangeHandler = function (name, options
        // eslint-disable-next-line sonarjs/cognitive-complexity
        ) {
            if (options === void 0) { options = {
                caster: "string",
                debounce: 0,
                useDirectValueChangeHandler: false,
            }; }
            // Actual change handler definition, uses curried property name to know what to set
            var reactFormDataChangeHandler = (0, mobx_1.action)("FormManager-ChangeHandler", function (e) {
                var caster = options.caster;
                var value = e.target.value;
                if (caster === "string")
                    value = String(value);
                if (caster === "number")
                    value = Number(value);
                if (caster === "boolean")
                    value = Boolean(value);
                if (caster === "array")
                    value = JSON.stringify(value);
                _this.setFormData(name, value);
            });
            // Bind this, add debounce
            reactFormDataChangeHandler = reactFormDataChangeHandler.bind(_this);
            var debounced = reactFormDataChangeHandler;
            if (options.debounce)
                debounced = (0, lodash_1.debounce)(reactFormDataChangeHandler, options.debounce);
            var manageCursorPosition = function (event) {
                var _a;
                var caret = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.selectionStart;
                var element = event === null || event === void 0 ? void 0 : event.target;
                if (caret && element) {
                    requestAnimationFrame(function () {
                        element.selectionStart = caret;
                        element.selectionEnd = caret;
                    });
                }
            };
            if (!options.useDirectValueChangeHandler) {
                // Persist event so debounce isn't an issue, then call debounced func.
                return function (e) {
                    var _a, _b;
                    // We have to catch the value here, because react will clean it up before debounce time elapses
                    var value = e.target.value;
                    (_a = e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                    (_b = e.persist) === null || _b === void 0 ? void 0 : _b.call(e);
                    manageCursorPosition(e);
                    return debounced(Object.assign(e || {}, { target: { value: value } }));
                };
            }
            return function (e) {
                var value = e;
                manageCursorPosition(e);
                return debounced(Object.assign(e || {}, { target: { value: value } }));
            };
        };
        this._validate = function () { return __awaiter(_this, void 0, void 0, function () {
            var validationSchema, errors, hasValidation, validationSchemaWithoutIgnoredFields, err_1, repeaterErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validationSchema = this._validationSchema;
                        errors = [];
                        hasValidation = Boolean(validationSchema);
                        if (!hasValidation)
                            return [2 /*return*/, []];
                        validationSchemaWithoutIgnoredFields = validationSchema.omit(Array.from(this.ignoreValidationOnTheseFields).map(function (key) {
                            return key.toString();
                        }));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, validationSchemaWithoutIgnoredFields.validate(this.getFormData({
                                withRepeatables: true,
                            }), {
                                abortEarly: false,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof yup.ValidationError) {
                            // If for some reason a different error was thrown, re-throw it.
                            if (!err_1.inner)
                                throw err_1;
                            // Its a yup error, as expected. carry on
                            errors = err_1.inner;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, Promise.all(Object.values(this.repeatedFormData).flatMap(function (fm) { var _a, _b; return (_b = (_a = fm).validate) === null || _b === void 0 ? void 0 : _b.call(_a); }))];
                    case 5:
                        repeaterErrors = _a.sent();
                        return [2 /*return*/, __spreadArray(__spreadArray([], errors, true), repeaterErrors.flat().filter(Boolean), true)];
                }
            });
        }); };
        this.validate = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._validate()];
                    case 1:
                        _a.errors = _b.sent();
                        return [2 /*return*/, this.errors];
                }
            });
        }); };
        this._validateField = function (fieldName) { return __awaiter(_this, void 0, void 0, function () {
            var validationSchema, errors, hasValidation, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validationSchema = this._validationSchema;
                        errors = [];
                        hasValidation = Boolean(validationSchema);
                        if (!hasValidation)
                            return [2 /*return*/, []];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, validationSchema.validateAt(fieldName.toString(), this.formData, {
                                abortEarly: false,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        if (err_2 instanceof yup.ValidationError) {
                            // If for some reason a different error was thrown, re-throw it.
                            if (!err_2.inner)
                                throw err_2;
                            // Its a yup error, as expected. carry on
                            errors = err_2.inner;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, errors];
                }
            });
        }); };
        this.validateField = function (fieldName) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._validateField(fieldName)];
                    case 1:
                        _a.errors = _b.sent();
                        return [2 /*return*/, this.errors];
                }
            });
        }); };
        this.validateFields = function (fieldNames) { return __awaiter(_this, void 0, void 0, function () {
            var errors, _i, fieldNames_1, fieldName, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        errors = [];
                        _i = 0, fieldNames_1 = fieldNames;
                        _c.label = 1;
                    case 1:
                        if (!(_i < fieldNames_1.length)) return [3 /*break*/, 4];
                        fieldName = fieldNames_1[_i];
                        _b = (_a = errors).push;
                        return [4 /*yield*/, this._validateField(fieldName)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.errors = errors.flat();
                        return [2 /*return*/, this.errors];
                }
            });
        }); };
        this.cast = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var validationSchema, hasValidation;
            return __generator(this, function (_a) {
                validationSchema = this._validationSchema;
                hasValidation = Boolean(validationSchema);
                if (!hasValidation)
                    return [2 /*return*/, data];
                return [2 /*return*/, validationSchema.cast(data)];
            });
        }); };
        this.getErrors = function (fieldName) {
            if (fieldName) {
                return _this.errors.filter(function (error) {
                    return fieldName ? error.path === fieldName : true;
                });
            }
            return _this.errors;
        };
        this.hasErrors = function (fieldName) {
            return _this.getErrors(fieldName).length > 0;
        };
        this.getErrorMessages = function (fieldName) {
            return _this.getErrors(fieldName).map(function (error) { return error.message; });
        };
        this.getFirstErrorMessage = function (fieldName) { var _a; return (_a = _this.getErrorMessages(fieldName)) === null || _a === void 0 ? void 0 : _a[0]; };
        /**
         * Creates a submit handler function, that automatically updates isSubmitting / errors
         */
        this.createSubmitHandler = function (func) {
            var submitHandler = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var validationErrors, customErrors, errors, data;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            (_a = e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                            (_b = e.persist) === null || _b === void 0 ? void 0 : _b.call(e);
                            this.isSubmitting = true;
                            return [4 /*yield*/, this._validate()];
                        case 1:
                            validationErrors = _c.sent();
                            customErrors = this.errors.filter(function (error) { return !(error instanceof yup.ValidationError); });
                            errors = __spreadArray(__spreadArray([], customErrors, true), validationErrors, true);
                            if (errors.length) {
                                this.isSubmitting = false;
                                this.errors = errors;
                                return [2 /*return*/];
                            }
                            this.errors = [];
                            return [4 /*yield*/, this.cast((0, lodash_2.cloneDeep)(__assign({}, this.getFormData({ withRepeatables: true }))))];
                        case 2:
                            data = (_c.sent());
                            return [4 /*yield*/, func(e, data, this)];
                        case 3:
                            _c.sent();
                            this.isSubmitting = false;
                            return [2 /*return*/];
                    }
                });
            }); };
            submitHandler = submitHandler.bind(_this);
            return submitHandler;
        };
        this.getProps = function (fieldName, options) {
            var changeHandler;
            if (options === null || options === void 0 ? void 0 : options.useDirectValueChangeHandler) {
                changeHandler = _this.getChangeHandler(fieldName, {
                    useDirectValueChangeHandler: Boolean(options.useDirectValueChangeHandler),
                    caster: options.caster,
                });
            }
            else {
                changeHandler = _this.getChangeHandler(fieldName, {
                    caster: options === null || options === void 0 ? void 0 : options.caster,
                });
            }
            var result = {
                name: fieldName,
                disabled: _this.isSubmitting,
                error: _this.hasErrors(fieldName),
                errorMessage: _this.getFirstErrorMessage(fieldName),
                onChange: changeHandler,
                value: _this.formData[fieldName],
            };
            return result;
        };
        this.reset = function () {
            _this.formData = (0, lodash_2.cloneDeep)(_this._initialData);
        };
        this.addError = function (errorMessage, path) {
            _this.errors.push({
                name: "error-" + (0, lodash_1.kebabCase)(errorMessage),
                value: errorMessage,
                errors: [],
                inner: [],
                message: errorMessage,
                path: path,
            });
        };
        this.addCustomError = function (errorMessage, path) {
            _this.errors.push({
                name: "error-" + (0, lodash_1.kebabCase)(errorMessage),
                value: errorMessage,
                errors: [errorMessage],
                inner: [],
                message: errorMessage,
                path: path,
            });
        };
        this.clearErrors = function (pathToRemove) {
            if (pathToRemove) {
                _this.errors = _this.errors.filter(function (_a) {
                    var path = _a.path;
                    return path !== pathToRemove;
                });
            }
            else {
                _this.errors = [];
            }
        };
        this.getInitialRepeaterData = function (fieldName) {
            var data = _this.getFormData()[fieldName];
            var typeguard = function (d) { return true; };
            if (typeguard(data)) {
                return data;
            }
            throw new Error("bah");
        };
        this._validationSchema = validationSchema;
        this._initialData = (0, lodash_2.cloneDeep)(formData);
        this.formData = formData;
        (0, mobx_1.makeAutoObservable)(this);
    }
    FormManager.prototype.setFormData = function (key, value) {
        this.formData[key] = value;
    };
    FormManager.prototype.getFormData = function (options) {
        if (options === void 0) { options = {
            withRepeatables: false,
        }; }
        return options.withRepeatables
            ? Object.assign((0, mobx_1.toJS)(this.formData), this.getRepeatedFormData())
            : (0, mobx_1.toJS)(this.formData);
    };
    FormManager.prototype.getRepeatedFormData = function (name) {
        var _this = this;
        if (!name) {
            return Object.fromEntries(Object.keys(this.repeatedFormData).map(function (key) { return [
                key,
                _this.getRepeatedFormDataByName(key),
            ]; }));
        }
        return this.getRepeatedFormDataByName(name);
    };
    FormManager.prototype.getRepeatedFormDataByName = function (name) {
        var data = this.repeatedFormData[name];
        return ((data === null || data === void 0 ? void 0 : data.map(function (entry) { return entry.getFormData(); }).map(function (entry) { return (0, lodash_1.mapKeys)(entry, function (val, key) { return removeSuffix(key); }); })) || []);
    };
    FormManager.prototype.setRepeatedFormDataByName = function (name, data) {
        var _this = this;
        this.repeatedFormData[name] = data.map(function (entry, i) {
            var _a;
            // In theory this should always resolve to a validation schemda for this repeater, or undefined
            var validation = (_a = _this._validationSchema) === null || _a === void 0 ? void 0 : _a[name];
            return new FormManager((0, lodash_1.mapKeys)(entry, function (_val, key) {
                return key + "-" + i;
            }), validation);
        });
    };
    return FormManager;
}());
exports.FormManager = FormManager;
exports.default = FormManager;
function removeSuffix(str) {
    return str.replace(/-\d+$/, "");
}
exports.removeSuffix = removeSuffix;
